export default function GetRiskIcon({riskLevel, size = 20}) {
    switch (riskLevel) {
      case 'HIGH':
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
              <path 
                d="M7 14L12 9L17 14" 
                stroke="rgb(222, 72, 72)" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                fill="none"
              />
              <path 
                d="M7 18L12 13L17 18" 
                stroke="rgb(222, 72, 72)" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                fill="none"
              />
            </svg>
          </div>
        );
      
      case 'MEDIUM':
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
              <path 
                d="M7 14L12 9L17 14" 
                stroke="rgb(234, 129, 36)" 
                strokeWidth="2.5" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                fill="none"
              />
            </svg>
          </div>
        );
      
      case 'LOW':
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
              <circle 
                cx="12" 
                cy="12"
                r="3.5" 
                fill="rgb(2, 175, 142)" 
                stroke="#02AF8E" 
                strokeWidth="1"
              />
            </svg>
          </div>
        );
      
      default:
        return <div style={{ display: 'flex', justifyContent: 'center' }}>-</div>;
    }
};